"use client";

import SvgArrow from "@/app/components/pages-components/blog-pages/bolg-details-page/details-helper/prev-next-blogs/SvgArrow";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useState } from "react";
import PopUp from "../../../pop-ups-components/pop-up-helpers/PopUp";
import Calendar from "../Calendar";
import SvgAppointmentGo from "../calendar-helpers/day-appointments-box/day-appointments-box-helpers/day-appointments/day-appointments-helpers/day-appointments-icons/SvgAppointmentGo";

const CalendarPopUp = ({ product, productState, disabled, form }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const { shouldConfig, variantNotExist, requiredAddonsNotChosen, outOfStock } =
    productState;

  const t = useTranslation();
  const isMobile = useIsMobile();
  return (
    <>
      <button
        className={`btn-product-add-to-cart ${disabled && "disabled"}`}
        disabled={disabled}
        onClick={() => !disabled && setIsOpen(true)}
      >
        {shouldConfig
          ? t.choose_variant
          : variantNotExist
          ? t.this_variant_not_available
          : outOfStock
          ? t.out_of_stock
          : requiredAddonsNotChosen
          ? t.choose_required_addons
          : t.book_now}
        <SvgAppointmentGo />
      </button>
      <PopUp
        style={{
          borderRadius: "0",
        }}
        fullScreen={isMobile}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div
          style={{
            padding: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            maxHeight: 800,
            overflow: "auto",
          }}
        >
          {isMobile && (
            <div
              role="button"
              onClick={() => setIsOpen(false)}
              className="d-flex align-items-center gap-2"
            >
              <SvgArrow />
              <span>{t.back}</span>
            </div>
          )}
          <div>
            <Calendar
              form={form}
              product={product}
              productState={productState}
            />
          </div>
        </div>
      </PopUp>
    </>
  );
};

export default CalendarPopUp;
